import React from 'react';
import { v4 as uuid } from 'uuid';
import { PropertyType } from '../../../common';
import styles from './GamePartners.module.scss';
import { gamePartnersListMap } from './GamePartners.const';
import { find } from 'lodash';
import { Button } from 'esa-ui-library';

export const getRows = (
	gamePartners: PropertyType[],
	columns: PropertyType[],
	onAction: (a: string, gamePartner: PropertyType) => void
): PropertyType[] => {
	const getActiveCells = (g: PropertyType): PropertyType[] => {
		const rows: PropertyType[] = [];
		columns.forEach((column) => {
			const field = find(gamePartnersListMap, ['label', column.label])?.value;
			const cellsMap = {
				gid: <span>{g.gid}</span>,
				name: <span>{g.name}</span>,
				partnerid: <span>{g.partnerid}</span>,
				partner_name: <span>{g.partner_name}</span>,
				skinid: <span>{g.skinid}</span>,
				external_id: <span>{g.external_id}</span>,
			};
			if (field) {
				rows.push((cellsMap as Record<string, JSX.Element>)[field]);
			}
		});
		// rows.unshift(<BulkSelect key={g.internal_game_id} id={`${g.internal_game_id}`} disabled />);
		rows.push(
			<span key={uuid()} className={styles.BtnBox}>
				<Button onClick={() => onAction('showGames', g)} title='Show Games' small className={styles.Btn} />
				<Button onClick={() => onAction('assignGames', g)} title='Assign Games' small className={styles.Btn} />
			</span>
		);
		return rows;
	};

	return gamePartners.map((g) => getActiveCells(g));
};
